import type { ReactNode } from 'react';

interface StatTileProps {
  label: string;
  value: ReactNode;
  foot?: ReactNode;
  accent?: string;
}

/**
 * A single headline number is not a chart — the form heuristic sends it to a
 * stat tile, where the value gets the weight and no axis is invented for it.
 */
export function StatTile({ label, value, foot, accent }: StatTileProps) {
  return (
    <div className="tile">
      {accent && <div className="tile__accent" style={{ background: accent }} />}
      <div className="tile__label">{label}</div>
      <div className="tile__value">{value}</div>
      {foot && <div className="tile__foot">{foot}</div>}
    </div>
  );
}
